export const URL_DIALOG_FLOW = process.env.REACT_APP_URL_DIALOG_FLOW;
export const TOKEN_HERO = process.env.REACT_APP_TOKEN_HERO;
export const TOKEN_OI_SEGURANCA = process.env.REACT_APP_TOKEN_OI_SEGURANCA;
export const TOKEN_FS_COVID19 = process.env.REACT_APP_TOKEN_FS_COVID19;
export const TOKEN_ENSINA_BY_FS_CAMPAIGN =
  process.env.REACT_APP_TOKEN_ENSINA_BY_FS_CAMPAIGN;
export const TOKEN_ENSINA_BY_FS = process.env.REACT_APP_TOKEN_ENSINA_BY_FS;
export const TOKEN_CLARO_E_FINANCAS =
  process.env.REACT_APP_TOKEN_CLARO_E_FINANCAS;
export const TOKEN_MUITOS_PREMIOS = process.env.REACT_APP_TOKEN_MUITOS_PREMIOS;
export const TOKEN_E_GESTOR = process.env.REACT_APP_TOKEN_E_GESTOR;
export const TOKEN_MANDA_PREMIOS = process.env.REACT_APP_TOKEN_MANDA_PREMIOS;
export const TOKEN_OI_SEU_NEGOCIO = process.env.REACT_APP_TOKEN_OI_SEU_NEGOCIO;
export const TOKEN_TIM_PROTECT = process.env.REACT_APP_TOKEN_TIM_PROTECT;
export const TOKEN_SUPORTE_DIGITAL =
  process.env.REACT_APP_TOKEN_SUPORTE_DIGITAL;
export const TOKEN_AUDIO_BOOKS = process.env.REACT_APP_TOKEN_AUDIO_BOOKS;
export const TOKEN_MULHERES_POSITIVAS =
  process.env.REACT_APP_TOKEN_MULHERES_POSITIVAS;
export const TOKEN_PROTECAO_PIX = process.env.REACT_APP_TOKEN_PROTECAO_PIX;
export const TOKEN_AYA_BOOKS = process.env.REACT_APP_TOKEN_AYA_BOOKS;
export const TOKEN_EQUILIBRAH = process.env.REACT_APP_TOKEN_EQUILIBRAH;
export const TOKEN_ENSINAH = process.env.REACT_APP_TOKEN_ENSINAH;
export const TOKEN_BANCAH = process.env.REACT_APP_TOKEN_BANCAH;
export const TOKEN_GESTAO_DIGITAL = process.env.REACT_APP_TOKEN_GESTAO_DIGITAL;
export const TOKEN_TESTEFONE = process.env.REACT_APP_TOKEN_TESTEFONE;
export const TOKEN_EXA_CLOUD = process.env.REACT_APP_TOKEN_EXA_CLOUD;
export const TOKEN_EXA_PROTEGE = process.env.REACT_APP_TOKEN_EXA_PROTEGE;
export const TOKEN_AYA_IDIOMAS = process.env.REACT_APP_TOKEN_AYA_IDIOMAS;

export const VARIABLES = [
  {
    name: 'hero',
    token: TOKEN_HERO,
    botName: 'Hector',
    botTitle: 'Assistente Virtual do EXA Segurança',
    headerImage: '/assets/images/logo/exa-seguranca.png',
    botIconImage: '/assets/images/icon/hero.png',
    botImage: '/assets/images/avatar/exa-seguranca.png',
    color: {
      button: '#004bc1',
      text: '#ffffff',
      border: '#004bc1',
    },
  },
  {
    name: 'oi-seguranca',
    token: TOKEN_OI_SEGURANCA,
    botName: 'Oi Segurança',
    botTitle: 'Assistente Virtual',
    headerImage: '/assets/images/logo/oi-seguranca.png',
    botIconImage: '/assets/images/icon/oi-seguranca.png',
    botImage: '/assets/images/avatar/oi-seguranca.png',
    color: {
      button: '#4cb848',
      text: '#ffffff',
      border: '#4cb848',
    },
  },
  {
    name: 'fs-covid-19',
    token: TOKEN_FS_COVID19,
    botName: 'FS',
    botTitle: 'Assistente Virtual da FS',
    headerImage: '/assets/images/logo/hero.png',
    botIconImage: '/assets/images/icon/hero.png',
    botImage: '/assets/images/avatar/hero.png',
    color: {
      button: '#37b3a7',
      text: '#ffffff',
      border: '#37b3a7',
    },
  },
  {
    name: 'ensina-by-fs-campaign',
    token: TOKEN_ENSINA_BY_FS_CAMPAIGN,
    botName: 'Sophia',
    botTitle: 'Assistente Virtual do Ensina by FS',
    headerImage: '/assets/images/logo/ensina.png',
    botIconImage: '/assets/images/icon/ensina.png',
    botImage: '/assets/images/avatar/ensina.png',
    color: {
      button: '#00c1b7',
      text: '#ffffff',
      border: '#00c1b7',
    },
  },
  {
    name: 'ensina-by-fs',
    token: TOKEN_ENSINA_BY_FS,
    botName: 'Sophia',
    botTitle: 'Assistente Virtual do Ensina by FS',
    headerImage: '/assets/images/logo/ensina.png',
    botIconImage: '/assets/images/icon/ensina.png',
    botImage: '/assets/images/avatar/ensina.png',
    color: {
      button: '#00c1b7',
      text: '#ffffff',
      border: '#00c1b7',
    },
  },
  {
    name: 'claro-e-financas',
    token: TOKEN_CLARO_E_FINANCAS,
    botName: '',
    botTitle: 'Assistente Virtual do Gestor e-Finanças',
    headerImage: '/assets/images/logo/claro-gestor-e-financas-logo.png',
    botIconImage: '/assets/images/icon/claro-gestor-e-financas-logo.png',
    botImage: '/assets/images/avatar/claro-gestor-e-financas-logo.png',
    color: {
      button: 'hsla(357, 77%, 52%, 1)',
      text: '#ffffff',
      border: 'hsla(357, 77%, 52%, 1)',
    },
  },
  {
    name: 'muitos-premios',
    token: TOKEN_MUITOS_PREMIOS,
    botName: 'Enrico',
    botTitle: 'Assistente Virtual da Promoção Muitos Prêmios',
    headerImage: '/assets/images/logo/muitos-premios.png',
    botIconImage: '/assets/images/icon/muitos-premios.png',
    botImage: '/assets/images/avatar/muitos-premios.jpg',
    color: {
      button: '#2A4280',
      text: '#ffffff',
      border: '#2A4280',
    },
  },
  {
    name: 'e-gestor',
    token: TOKEN_E_GESTOR,
    botName: 'Sistema de Gestão Empresarial',
    botTitle: 'Assistente Virtual',
    headerImage: '/assets/images/logo/oi-seguranca.png',
    botIconImage: '/assets/images/icon/oi-seguranca.png',
    botImage: '/assets/images/avatar/oi-seguranca.png',
    color: {
      button: 'hsla(247.7, 62.2%, 46.7%, 1)',
      text: '#ffffff',
      border: 'hsla(247.7, 62.2%, 46.7%, 1)',
    },
  },
  {
    name: 'manda-premios',
    token: TOKEN_MANDA_PREMIOS,
    botName: 'Enrico',
    botTitle: 'Assistente Virtual da Promoção Manda Prêmios',
    headerImage: '/assets/images/logo/manda-premios.png',
    botIconImage: '/assets/images/icon/manda-premios.png',
    botImage: '/assets/images/avatar/muitos-premios.jpg',
    color: {
      button: '#2A4280',
      text: '#ffffff',
      border: '#2A4280',
    },
  },
  {
    name: 'oi-seu-negocio',
    token: TOKEN_OI_SEU_NEGOCIO,
    botName: 'Oi Seu Negócio',
    botTitle: 'Assistente Virtual do Oi Seu Negócio',
    headerImage: '/assets/images/logo/oi-seu-negocio.png',
    botIconImage: '/assets/images/icon/oi-seu-negocio.png',
    botImage: '/assets/images/avatar/oi-seu-negocio.png',
    color: {
      button: '#4cb848',
      text: '#ffffff',
      border: '#4cb848',
    },
  },
  {
    name: 'tim-protect',
    token: TOKEN_TIM_PROTECT,
    botName: 'Tim Segurança Digital',
    botTitle: 'Assistente Virtual',
    headerImage: '/assets/images/logo/tim-protect.png',
    botIconImage: '/assets/images/icon/tim-protect.png',
    botImage: '/assets/images/avatar/tim-protect.png',
    color: {
      button: '#004691',
      text: '#ffffff',
      border: '#004691',
    },
  },
  {
    name: 'suporte-digital',
    token: TOKEN_SUPORTE_DIGITAL,
    botName: 'Suporte Digital',
    botTitle: 'Suporte Digital',
    headerImage: '/assets/images/logo/suporte-digital.png',
    botIconImage: '/assets/images/icon/suporte-digital.png',
    botImage: '/assets/images/avatar/hero.png',
    color: {
      button: '#004691',
      text: '#ffffff',
      border: '#004691',
    },
  },
  {
    name: 'ensina-financas',
    token: TOKEN_ENSINA_BY_FS,
    botName: 'Ensina Finanças',
    botTitle: 'Assistente Virtual do Ensina Finanças',
    headerImage: '/assets/images/logo/ensina-financas.png',
    botIconImage: '/assets/images/icon/ensina.png',
    botImage: '/assets/images/avatar/ensina.png',
    color: {
      button: '#1ba831',
      text: '#ffffff',
      border: '#1ba831',
    },
  },
  {
    name: 'ensina-beta',
    token: TOKEN_ENSINA_BY_FS,
    botName: 'Ensina Beta',
    botTitle: 'Assistente Virtual do Ensina Beta',
    headerImage: '/assets/images/logo/ensina-beta.png',
    botIconImage: '/assets/images/icon/ensina.png',
    botImage: '/assets/images/avatar/ensina.png',
    color: {
      button: '#555EC0',
      text: '#ffffff',
      border: '#555EC0',
    },
  },
  {
    name: 'audio-books',
    token: TOKEN_AUDIO_BOOKS,
    botName: ' AudioBooks By Ubook GO',
    botTitle: 'Assistente Virtual',
    headerImage: '/assets/images/logo/ubook-go.png',
    botIconImage: '/assets/images/icon/ubook-go.png',
    botImage: '/assets/images/avatar/ubook-go.png',
    color: {
      button: '#ff5b00',
      text: '#ffffff',
      border: '#ff5b00',
    },
  },
  {
    name: 'mulheres-positivas',
    token: TOKEN_MULHERES_POSITIVAS,
    botName: 'Mulheres Positivas',
    botTitle: 'Mulheres Positivas - Assistente Virtual',
    headerImage: '/assets/images/logo/mulheres-positivas.jpg',
    botIconImage: '/assets/images/icon/mulheres-positivas.png',
    botImage: '/assets/images/avatar/mulheres-positivas.png',
    color: {
      button: '#266A69',
      text: '#ffffff',
      border: '#266A69',
    },
  },
  {
    name: 'protecao-pix',
    token: TOKEN_PROTECAO_PIX,
    botName: 'Proteção Pix',
    botTitle: 'Proteção Pix - Assistente Virtual',
    headerImage: '/assets/images/logo/protecao-pix.png',
    botIconImage: '/assets/images/icon/protecao-pix.png',
    botImage: '/assets/images/avatar/protecao-pix.png',
    color: {
      button: '#C70059',
      text: '#ffffff',
      border: '#2DBCB5',
    },
  },
  {
    name: 'aya-books',
    token: TOKEN_AYA_BOOKS,
    botName: 'Aya Books',
    botTitle: 'Assistente Virtual',
    headerImage: '/assets/images/logo/aya-books.png',
    botIconImage: '/assets/images/icon/aya-books.png',
    botImage: '/assets/images/avatar/aya-books.png',
    color: {
      button: '#29b0b3',
      text: '#ffffff',
      border: '#29b0b3',
    },
  },
  {
    name: 'equilibrah',
    token: TOKEN_EQUILIBRAH,
    botName: 'Equilibrah',
    botTitle: 'Assistente Virtual',
    headerImage: '/assets/images/logo/aya-equilibrah.png',
    botIconImage: '/assets/images/icon/aya-books.png',
    botImage: '/assets/images/avatar/equilibrah.png',
    color: {
      button: '#29b0b3',
      text: '#ffffff',
      border: '#29b0b3',
    },
  },
  {
    name: 'ensinah',
    token: TOKEN_ENSINAH,
    botName: 'Ensinah',
    botTitle: 'Assistente Virtual',
    headerImage: '/assets/images/logo/aya-ensinah-azul.png',
    botIconImage: '/assets/images/icon/aya-books.png',
    botImage: '/assets/images/avatar/ensinah.png',
    color: {
      button: '#29b0b3',
      text: '#ffffff',
      border: '#29b0b3',
    },
  },
  {
    name: 'bancah',
    token: TOKEN_BANCAH,
    botName: 'Bancah',
    botTitle: 'Assistente Virtual',
    headerImage: '/assets/images/logo/bancah.png',
    botIconImage: '/assets/images/icon/bancah.png',
    botImage: '/assets/images/avatar/bancah.png',
    color: {
      button: '#29b0b3',
      text: '#ffffff',
      border: '#29b0b3',
    },
  },
  {
    name: 'gestao-digital',
    token: TOKEN_GESTAO_DIGITAL,
    botName: 'Gestão Digital',
    botTitle: 'Assistente Virtual',
    headerImage: '/assets/images/logo/exa-gestao.png',
    botIconImage: '/assets/images/icon/exa-gestao-icon.png',
    botImage: '/assets/images/avatar/exa-gestao-icon.png',
    color: {
      button: '#2665cc',
      text: '#ffffff',
      border: '#2665cc',
    },
  },
  {
    name: 'testefone',
    token: TOKEN_TESTEFONE,
    botName: 'Testefone',
    botTitle: 'Assistente Virtual',
    headerImage: '/assets/images/logo/testefone-logo.png',
    botIconImage: '/assets/images/icon/testefone-icon.png',
    botImage: '/assets/images/avatar/testefone-avatar.png',
    color: {
      button: '#2665cc',
      text: '#ffffff',
      border: '#2665cc',
    },
  },
  {
    name: 'exa-cloud',
    token: TOKEN_EXA_CLOUD,
    botName: 'Hector',
    botTitle: 'EXA Cloud',
    headerImage: '/assets/images/logo/logo_cloud.png',
    botIconImage: '/assets/images/icon/logo_exa_cloud_icon.png',
    botImage: '/assets/images/avatar/exa-seguranca.png',
    color: {
      button: '#004bc1',
      text: '#ffffff',
      border: '#004bc1',
    },
  },
  {
    name: 'exa-protege',
    token: TOKEN_EXA_PROTEGE,
    botName: 'EXA Protege',
    botTitle: 'EXA Protege',
    headerImage: '/assets/images/logo/exa_protege.png',
    botIconImage: '/assets/images/icon/exa_protege.png',
    botImage: '/assets/images/avatar/exa_protege_avatar.png',
    color: {
      button: '#004bc1',
      text: '#ffffff',
      border: '#004bc1',
    },
  },
  {
    name: 'aya-idiomas',
    token: TOKEN_AYA_IDIOMAS,
    botName: 'AYA Idiomas',
    botTitle: 'AYA Idiomas',
    headerImage: '/assets/images/logo/aya-idiomas-logo.png',
    botIconImage: '/assets/images/icon/aya-idiomas-icon.png',
    botImage: '/assets/images/avatar/aya_idiomas_avatar.png',
    color: {
      button: '#004bc1',
      text: '#ffffff',
      border: '#004bc1',
    },
  },
];
